export default function() {
  const firstText = document.querySelector(
    `.left-column h3, .left-column h2, .left-column p`
  );
  firstText.classList.add(`no-top-margin`);
}
